
export const procurements = [
  {
    id: 1,
    title: 'Koulujen ruokapalveluiden kilpailuttaminen',
    description: 'Kaupungin peruskoulujen ja lukioiden ruokapalveluiden kokonaisuudistus. Tavoitteena on parantaa ruoan laatua ja kestävyyttä sekä huomioida erityisruokavaliot entistä paremmin.',
    city: 'Helsinki',
    category: 'Ruokapalvelut',
    subcategory: 'Kouluruokailu',
    value_band: 'III',
    value_estimate: '2.5M€',
    planned_competition_start: '2025-03-15',
    planned_competition_end: '2025-04-30',
    status: 'Suunniteltu',
    contact_name: 'Marja Korhonen',
    contact_email: 'marja.korhonen@helsinki.fi',
    contact_phone: '+358 9 310 12345',
    updated_at: '2025-01-15',
    tags: ['Kestävyys', 'Erityisruokavaliot', 'Laatu']
  },
  {
    id: 2,
    title: 'IT-palveluiden kehittäminen ja ylläpito',
    description: 'Kaupungin tietojärjestelmien modernisointiprojekti sisältäen pilvipalvelut, tietoturvan parantamisen ja käyttäjätuen uudistamisen.',
    city: 'Tampere',
    category: 'IT-palvelut',
    subcategory: 'Järjestelmäkehitys',
    value_band: 'IV',
    value_estimate: '12M€',
    planned_competition_start: '2025-02-01',
    planned_competition_end: '2025-03-31',
    status: 'Käynnissä',
    contact_name: 'Jukka Virtanen',
    contact_email: 'jukka.virtanen@tampere.fi',
    contact_phone: '+358 3 565 6789',
    updated_at: '2025-01-14',
    tags: ['Digitalisaatio', 'Pilvipalvelut', 'Tietoturva']
  },
  {
    id: 3,
    title: 'Puistojen hoito ja ylläpito',
    description: 'Kaupungin viheralueiden hoitopalveluiden kilpailuttaminen kattaen puistojen ylläpidon, leikkikenttien huollon ja kasvien istutuksen.',
    city: 'Turku',
    category: 'Kiinteistöpalvelut',
    subcategory: 'Viheralueiden hoito',
    value_band: 'II',
    value_estimate: '180K€',
    planned_competition_start: '2025-04-01',
    planned_competition_end: '2025-05-15',
    status: 'Suunniteltu',
    contact_name: 'Anna Lindström',
    contact_email: 'anna.lindstrom@turku.fi',
    contact_phone: '+358 2 262 7890',
    updated_at: '2025-01-13',
    tags: ['Viheralueet', 'Ylläpito', 'Kestävyys']
  },
  {
    id: 4,
    title: 'Sosiaalitoimen kuljetuspalvelut',
    description: 'Vammaispalveluiden ja vanhustenhuollon kuljetuspalveluiden järjestäminen. Palvelu sisältää saattajapalvelut ja erikoiskuljetukset.',
    city: 'Oulu',
    category: 'Sosiaali- ja terveyspalvelut',
    subcategory: 'Kuljetuspalvelut',
    value_band: 'II',
    value_estimate: '95K€',
    planned_competition_start: '2025-06-01',
    planned_competition_end: '2025-07-15',
    status: 'Suunniteltu',
    contact_name: 'Kaisa Mäkinen',
    contact_email: 'kaisa.makinen@oulu.fi',
    contact_phone: '+358 8 558 4567',
    updated_at: '2025-01-12',
    tags: ['Vammaispalvelut', 'Vanhustenhuolto', 'Saavutettavuus']
  },
  {
    id: 5,
    title: 'Energiatehokkuuden parantaminen',
    description: 'Julkisten rakennusten energiatehokkuuden parantamisprojekti sisältäen lämmitysjärjestelmien uudistamisen ja älykkään energianhallinnan.',
    city: 'Jyväskylä',
    category: 'Rakennuspalvelut',
    subcategory: 'Energiapalvelut',
    value_band: 'III',
    value_estimate: '3.2M€',
    planned_competition_start: '2025-03-01',
    planned_competition_end: '2025-04-15',
    status: 'Käynnissä',
    contact_name: 'Pekka Hautala',
    contact_email: 'pekka.hautala@jyvaskyla.fi',
    contact_phone: '+358 14 266 1234',
    updated_at: '2025-01-11',
    tags: ['Energiatehokkuus', 'Kestävyys', 'Älykkäät järjestelmät']
  },
  {
    id: 6,
    title: 'Kirjastojen digitaaliset palvelut',
    description: 'Kirjastojen digitaalisten palveluiden kehittäminen sisältäen e-kirjapalvelut, digitaaliset oppimisympäristöt ja verkkokurssialusta.',
    city: 'Lahti',
    category: 'Kulttuuri- ja vapaa-aikapalvelut',
    subcategory: 'Kirjastopalvelut',
    value_band: 'I',
    value_estimate: '45K€',
    planned_competition_start: '2025-05-01',
    planned_competition_end: '2025-06-30',
    status: 'Suunniteltu',
    contact_name: 'Sari Nieminen',
    contact_email: 'sari.nieminen@lahti.fi',
    contact_phone: '+358 3 814 5678',
    updated_at: '2025-01-10',
    tags: ['Digitaaliset palvelut', 'Oppiminen', 'Kulttuuri']
  },
  {
    id: 7,
    title: 'Jätehuollon tehostaminen',
    description: 'Kierrätyksen ja jätehuollon palveluiden kilpailuttaminen. Tavoitteena on parantaa lajittelua ja vähentää kaatopaikalle menevän jätteen määrää.',
    city: 'Kuopio',
    category: 'Ympäristöpalvelut',
    subcategory: 'Jätehuolto',
    value_band: 'II',
    value_estimate: '155K€',
    planned_competition_start: '2025-07-01',
    planned_competition_end: '2025-08-31',
    status: 'Suunniteltu',
    contact_name: 'Risto Järvinen',
    contact_email: 'risto.jarvinen@kuopio.fi',
    contact_phone: '+358 17 182 3456',
    updated_at: '2025-01-09',
    tags: ['Kierrätys', 'Ympäristö', 'Kestävyys']
  },
  {
    id: 8,
    title: 'Katujen kunnossapito ja talvihoito',
    description: 'Kaupungin katuverkon ylläpito ja talvihoitopalvelut sisältäen lumenaurauk sen, liukkaudentorjunnan ja kevätsiivouksen.',
    city: 'Pori',
    category: 'Tekninen toimi',
    subcategory: 'Katujen ylläpito',
    value_band: 'III',
    value_estimate: '1.8M€',
    planned_competition_start: '2025-08-01',
    planned_competition_end: '2025-09-30',
    status: 'Suunniteltu',
    contact_name: 'Mikko Salo',
    contact_email: 'mikko.salo@pori.fi',
    contact_phone: '+358 2 621 1111',
    updated_at: '2025-01-08',
    tags: ['Infrastruktuuri', 'Talvihoito', 'Kunnossapito']
  }
];

export const cities = [
  'Helsinki',
  'Tampere',
  'Turku',
  'Oulu',
  'Jyväskylä',
  'Lahti',
  'Kuopio',
  'Pori',
  'Kouvola',
  'Kotka',
  'Joensuu',
  'Lappeenranta'
];

export const categories = [
  { id: 'ruokapalvelut', name: 'Ruokapalvelut', subcategories: ['Kouluruokailu', 'Henkilöstöruokailu', 'Catering'] },
  { id: 'it-palvelut', name: 'IT-palvelut', subcategories: ['Järjestelmäkehitys', 'Pilvipalvelut', 'Tietoturva'] },
  { id: 'kiinteistopalvelut', name: 'Kiinteistöpalvelut', subcategories: ['Siivouspalvelut', 'Viheralueiden hoito', 'Kiinteistönhuolto'] },
  { id: 'sosiaali-terveyspalvelut', name: 'Sosiaali- ja terveyspalvelut', subcategories: ['Kuljetuspalvelut', 'Hoivapalvelut', 'Terapiapalvelut'] },
  { id: 'rakennuspalvelut', name: 'Rakennuspalvelut', subcategories: ['Energiapalvelut', 'Korjausrakentaminen', 'Uudisrakentaminen'] },
  { id: 'kulttuuri-vapaa-aika', name: 'Kulttuuri- ja vapaa-aikapalvelut', subcategories: ['Kirjastopalvelut', 'Liikuntapalvelut', 'Nuorisopalvelut'] },
  { id: 'ymparistopalvelut', name: 'Ympäristöpalvelut', subcategories: ['Jätehuolto', 'Vesihuolto', 'Ympäristönsuojelu'] },
  { id: 'tekninen-toimi', name: 'Tekninen toimi', subcategories: ['Katujen ylläpito', 'Liikennepalvelut', 'Rakennusvalvonta'] }
];

export const valueBands = [
  { id: 'I', name: 'I', range: '9-60K€', description: 'Kansallinen kynnysarvo: 9 000 - 60 000 €' },
  { id: 'II', name: 'II', range: '60-221K€', description: 'EU-kynnysarvo palvelut: 60 000 - 221 000 €' },
  { id: 'III', name: 'III', range: '222K-5M€', description: 'EU-kynnysarvo rakennusurakat: 222 000 € - 5 000 000 €' },
  { id: 'IV', name: 'IV', range: '&gt;5M€', description: 'Suuret hankinnat: yli 5 000 000 €' }
];

export const statuses = [
  { id: 'suunniteltu', name: 'Suunniteltu' },
  { id: 'kaynnissa', name: 'Käynnissä' },
  { id: 'arkistoitu', name: 'Arkistoitu' }
];
